import { Button, Col, Pagination, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import toastr from 'toastr';
import moment from "moment";
import { JobsServiceApi } from '../../../api';
import { getRequest } from '../../../api/http';
import { LoadingView } from '../../common';
import './index.scss';
import placementOfficer from '../../../api/placementOfficer';

export default function StudentHistory(props) {

    const windowScreen = window.innerWidth;
    const navigate = useNavigate();
    const location = useLocation();
    const eventId = location.state?.eventId;
    const { studentId } = useParams()
    const [loading, setloading] = useState(true)
    const [studentJobHistroy, setStudentJobHistroy] = useState([])
    const [jobs, setJobs] = useState([])

    const fetchStudentJobHistroy = async () => {
        try {
            // eslint-disable-next-line no-unused-vars
            const response = await getRequest(placementOfficer.getStudentById(eventId, studentId));
            console.log("response", response);
            setStudentJobHistroy(response)
            if (response) {

                setloading(false)
            }
        } catch (e) {
            setloading(false)
            toastr.error(e.message);
        }
    };
    const fetchJobsbyId = async () => {
        try {
            // eslint-disable-next-line no-unused-vars
            const response = await getRequest(placementOfficer.getStudentJobsbyId(eventId, studentId));
            console.log("Jobs", response);
            setJobs(response)
            if (response) {

                setloading(false)
            }
        } catch (e) {
            setloading(false)
            toastr.error(e.message);
        }
    };

    useEffect(() => {
        fetchStudentJobHistroy()
        fetchJobsbyId()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const columns = [

        {
            title: 'S.No.',
            dataIndex: 'serialNumber',
            key: 'serialNumber',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Job Name',
            dataIndex: 'title',
            key: 'jobTitle',
        },

        {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
        },
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'date',
            render: (text, record) => (
                <div>
                    {moment(text).format('DD-MM-YYYY')}
                </div>
            ),
        },
        // {
        //     title: 'Result',
        //     dataIndex: 'assessmentResult',
        //     key: 'assessmentResult',
        //     render: (text, record) => (
        //         <div>
        //             {text ? text : "--"}
        //         </div>
        //     ),
        // },
        // {
        //     title: 'Score',
        //     dataIndex: 'assessmentScore',
        //     key: 'assessmentScore',
        //     render: (text, record) => (
        //         <div>
        //             {text ? text : "--"}
        //         </div>
        //     ),
        // },
        {
            title: 'Status',
            dataIndex: 'applicationStatus',
            key: 'status',
            render: (text, record) => (
                <div>
                    {textUpperCase(text)}
                </div>
            ),
        }
    ];

    const columnMobile = [
        {
            title: 'Job Name',
            dataIndex: 'jobTitle',
            key: 'jobTitle',
        },
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            key: 'company',
        }
    ];

    function onChangeGetTableData() {

    }

    const textUpperCase = (val) => {
        return val.replace(/_/g, " ").toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }

    const renderCandidatesList = () => {
        if (loading) return <LoadingView message="Loading..." />;
        return (
            <div>
                {
                    windowScreen > 667 ? (
                        <Table pagination={false} dataSource={jobs?.content} columns={columns} className="TemplateTable desktopTableView" />
                    ) : (
                        <Table
                            className='mobileTableView TemplateTable'
                            columns={columnMobile}
                            // dataSource={studentJobHistroy?.studentJobApplicationOutputs}
                            pagination={false}
                            rowKey={(record) => record?.id}
                            expandable={{
                                expandedRowRender: (record) => (
                                    <div className='expandableContent'>
                                        <div className='expandableRow'>
                                            <div className='expandableColHead'>Date</div>
                                            <div className='expandableColValue'>
                                                {moment(record?.assessmentResult).format('DD-MM-YYYY')}
                                            </div>
                                        </div>
                                        <div className='expandableRow'>
                                            <div className='expandableColHead'>Result</div>
                                            <div className='expandableColValue'>
                                                {record?.assessmentResult}
                                            </div>
                                        </div>
                                        <div className='expandableRow'>
                                            <div className='expandableColHead'>Score</div>
                                            <div className='expandableColValue'>
                                                {record?.assessmentScore}
                                            </div>
                                        </div>
                                        <div className='expandableRow'>
                                            <div className='expandableColHead'>Status</div>
                                            <div className='expandableColValue'>
                                                {textUpperCase(record?.status)}
                                            </div>
                                        </div>
                                    </div>
                                ),
                            }}
                        />
                    )
                }
                <div className='paginationRow adminPaginationRow'>
                    <Pagination
                        showSizeChanger
                        current={0}
                        pageSize={0}
                        total={0}
                        onChange={onChangeGetTableData}
                    />
                </div>
            </div>
        )
    };
    const handleResumeClick = () => {
        // Navigate to the route where the resume is displayed
        navigate(`/view-profile/${studentId}`, { state: { eventId } });
    };
    return (
        <div className="container student-job-histroy">
            <div className="headingContainer">
                <div className="headingTitle"><h3>Student Profile</h3></div>
                <div className="headingButton" >
                    <Button type="primary" onClick={handleResumeClick} style={{ marginRight: '5px' }}>Resume</Button>
                    <Button onClick={() => navigate(-1)} type="primary">Back</Button>
                </div>
            </div>
            {studentJobHistroy?.name &&
                <div className='student-profile-card'>

                    <Col>
                        <Row className='student-profile'>
                            <Col lg={12} sm={24} xs={24}>
                                <div className='student-profile-row'>
                                    <div className='student-profile-col'>
                                        Student name
                                    </div>
                                    <div className='student-profile-col'>
                                        {studentJobHistroy?.name}
                                    </div>
                                </div>
                            </Col>
                            <Col lg={12} sm={24} xs={24}>
                                <div className='student-profile-row'>
                                    <div className='student-profile-col'>
                                        Email
                                    </div>
                                    <div className='student-profile-col'>
                                        {studentJobHistroy?.email}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className='student-profile'>
                            <Col lg={12} sm={24} xs={24}>
                                <div className='student-profile-row'>
                                    <div className='student-profile-col'>
                                        Phone
                                    </div>
                                    <div className='student-profile-col'>
                                        {studentJobHistroy?.phone}
                                    </div>
                                </div>
                            </Col>
                            <Col lg={12} sm={24} xs={24}>
                                <div className='student-profile-row'>
                                    <div className='student-profile-col'>
                                        Skills
                                    </div>
                                    <div className='student-profile-col'>
                                        {studentJobHistroy?.skills?.slice(0, 5).map((skill, index) => (
                                            <span key={index}>
                                                {skill}{index !== studentJobHistroy.skills.length - 1 && ' , '}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </div>}
            <div className="">
                {renderCandidatesList()}
            </div>
        </div>
    )
}